import throttle from 'lodash/throttle';

class StickyHeader {
    constructor() {
        this.scrollpos = window.scrollY || document.body.scrollTop || 0;
        this.header = document.getElementById("header");
        this.body = document.getElementById("body");
        this.lastScroll = 90
        this.alreadyLoaded = false
        this.productimages = document.querySelector(".product-images");
        this.productbasket = document.getElementById("productbasket");
        this.productbasketHeight;
        this.init();
    }
    /** Add & Remove classes when hiding Header */
    headerHide() {
        this.header.classList.add("animate-fadeOutUp")
        this.header.classList.remove("animate-fadeInDown")
    }
    /** Add & Remove classes when showing Header */
    headerShow() {
        if (this.alreadyLoaded) {
            this.header.classList.add("animate-fadeInDown")
            this.header.classList.remove("animate-fadeOutUp")
        } else {
            this.alreadyLoaded = true
        }
    }
    addRemoveClassesHeader() {
        this.scrollpos = window.scrollY || document.body.scrollTop || 0;
        this.half = this.body.offsetHeight / 3.5;
        if (this.scrollpos >= this.header.offsetHeight) {
            this.body.classList.add("js-header-sticky");
        } else {
            this.body.classList.remove("js-header-sticky");
        }
        if (this.scrollpos >= this.half) {
            this.body.classList.add("js-body-halfway");
        } else {
            this.body.classList.remove("js-body-halfway");
        }

        // Scroll direction
        const currentScroll = window.scrollY 
        const isNavOpen = () => {
            return this.body.classList.contains('js-nav-open')
        }

        if (currentScroll == 0 && !isNavOpen()) {
            this.headerShow()
            return;
        }

        if (!isNavOpen()) {
            if ((currentScroll > (this.lastScroll + 70)) && (currentScroll > 50)) {
                this.headerHide()
            } else if (currentScroll < this.lastScroll) {
                this.headerShow()
            }
            this.lastScroll = currentScroll
        }

    }
    addRemoveClassesBasket() {
        if (this.productbasket) {
            this.scrollpos = window.scrollY || document.body.scrollTop || 0;
            if (this.scrollpos >= (this.productbasket.offsetHeight + 300)) {
                this.body.classList.add("js-basket-sticky");
            } else {
                this.body.classList.remove("js-basket-sticky");
            }
        }
    }
    init() {
        this.addRemoveClassesHeader();
        this.addRemoveClassesBasket();

        window.addEventListener("scroll", throttle(() => {
            this.addRemoveClassesHeader();
            this.addRemoveClassesBasket();
        }, 100));
    }
}
export default StickyHeader;